/**
 * DealStageBadge — Color-coded pill showing deal lifecycle stage.
 */

const STAGE_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  screening: { bg: "rgba(59, 130, 246, 0.15)", text: "#60a5fa", label: "Screening" },
  active: { bg: "rgba(16, 185, 129, 0.15)", text: "#34d399", label: "Active" },
  diligence: { bg: "rgba(234, 179, 8, 0.15)", text: "#fbbf24", label: "Due Diligence" },
  paused: { bg: "rgba(148, 163, 184, 0.15)", text: "#94a3b8", label: "Paused" },
  closed_won: { bg: "rgba(16, 185, 129, 0.15)", text: "#10b981", label: "Closed Won" },
  closed_lost: { bg: "rgba(239, 68, 68, 0.15)", text: "#f87171", label: "Closed Lost" },
};

interface DealStageBadgeProps {
  stage: string;
}

export default function DealStageBadge({ stage }: DealStageBadgeProps) {
  const config = STAGE_COLORS[stage] ?? STAGE_COLORS.screening!;
  return (
    <span
      className="stage-badge"
      style={{
        background: config.bg,
        color: config.text,
        padding: "2px 10px",
        borderRadius: "12px",
        fontSize: "11px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        whiteSpace: "nowrap",
      }}
    >
      {config.label}
    </span>
  );
}
